import {useRef} from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {AccountPageFragment as Account} from 'nutshell-graphql-types';

import {useCoreEntityWorkspaceSidebarCollapsed} from '../../../core-entity/hooks/use-core-entity-workspace-sidebar-collapsed';
import {CoreEntityContent} from '../../../core-entity/layout/core-entity-content';

import {AccountHeaderMiniOnScroll} from '../header-fixed/account-header-mini-on-scroll';

import {AccountActionBar} from './action-bar/account-action-bar';
import {WorkspaceSection} from './workspace-section/workspace-section';

type Props = {
    account: Account;
    scrollContainerRef: HTMLDivElement | null | undefined;
    user: User;
    hasScrolledPastCheckpoint: boolean;
    getActionBarRef: (ref: HTMLDivElement | null) => void;
    isSidebarCollapsed: boolean;
    scrollContainerTop: number;
    onUpdateAssignee: (assigneeId: string | null) => Promise<any>;
    onUpdateDeletedStatus: (isDeleted: boolean) => Promise<any>;
    onHardDelete: () => Promise<any>;
    hasFullHeightSidebar?: boolean;
};

export function AccountContent(props: Props) {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const {isWorkspaceSidebarCollapsed, handleModeChange} = useCoreEntityWorkspaceSidebarCollapsed(
        props.isSidebarCollapsed,
        'account'
    );

    return (
        <CoreEntityContent
            contentRef={contentRef}
            hasFullHeightSidebar={props.hasFullHeightSidebar}
        >
            <AccountHeaderMiniOnScroll
                scrollContainerTop={props.scrollContainerTop}
                isShown={props.hasScrolledPastCheckpoint}
                contentRef={contentRef}
                account={props.account}
                user={props.user}
                onUpdateAssignee={props.onUpdateAssignee}
                onUpdateDeletedStatus={props.onUpdateDeletedStatus}
                onHardDelete={props.onHardDelete}
            />
            <AccountActionBar
                account={props.account}
                user={props.user}
                getRef={props.getActionBarRef}
                hasScrolledPastCheckpoint={props.hasScrolledPastCheckpoint}
            />
            <WorkspaceSection
                account={props.account}
                scrollContainerRef={props.scrollContainerRef}
                isSidebarCollapsed={props.isSidebarCollapsed}
                isWorkspaceSidebarCollapsed={isWorkspaceSidebarCollapsed}
                onIsWorkspaceSidebarCollapsedChange={handleModeChange}
                user={props.user}
                hasFullHeightSidebar={props.hasFullHeightSidebar}
            />
        </CoreEntityContent>
    );
}
